import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import FormBloc from "../../../../bloc/forms_bloc";
import GeneralBloc from "../../../../bloc/general_bloc";
import HomeBloc from "../../../../bloc/home_bloc";
import RouteBloc from "../../../../bloc/route_bloc";
import UserAccessBloc from "../../../../bloc/user_access_bloc";
import UtilBloc from "../../../../bloc/util_bloc";
import Config from "../../../../Config";
import AppSelectButton from "../../../component/app_select_button/app_select_button";
import AppSelectField from "../../../component/app_select_field/app_select_field";
import AppTextField from "../../../component/app_text_field/app_text_field";
import {
    decimalNumberValidation,
    isContainNumberOnly,
    nameValidation,
    nricValidation,
    phoneNumberValidation
} from "../../../component/app_validation";
import "./proposal_form.css";
import moment from "moment";
import FormsBloc from "../../../../bloc/forms_bloc";
import { DatePicker } from "antd";

const initiateDetailsObject = {
    relationshipToPersonCovered: null,
    specifyRelationship: null,
    name: null,
    idType: null,
    idNo: null,
    dob: null,
    nationality: null,
    natureBusiness: null,
    corrCountry: null,
    correspondenceAddress: null,
    correspondenceAddress2: null,
    correspondenceAddress3: null,
    isResidentialAddressCorrespondenceAddress: 'Yes',
    corrState: null,
    corrPostcode: null,
    corrCity: null,
    residentialCountry: null,
    residentialState: null,
    residentialPostcode: null,
    residentialCity: null,
    residentialAddress: null,
    residentialAddress2: null,
    residentialAddress3: null,
    occupation: null,
    occupationClass: null,
    annualIncome: null,
    exactAnnualIncome: null,
    mobileNo: null,
    officePhoneNo: null,
    homePhoneNo: null,
    email: null,
    companyName: null,
    companyAddress: null,
    companyAddress2: null,
    companyAddress3: null,
    companyCountry: null,
    companyState: null,
    companyPostcode: null,
    companyCity: null,
    isPayorPersonCovered: null,
    addIDType: null,
    oldIcNo: null,
    birthCertNo: null,
}

class ContributorPersonalInfo extends Component {
    constructor(props) {
        super(props);
        let routeParams = RouteBloc.extractRouteParamsFromProps(props);
        this.state = {
            route: routeParams,
            client: Config.context,
            userDataHeader: null,
            userSettings: {},
            personalDetailsData: { ...initiateDetailsObject },

            errorMessage: 'Fill in the required field.',
            placeOfBirthErrMsg: null,
            salutationList: null,
            countryList: null,
            stateList: null,
            foreignStateList: null,
            corrForeignStateList: null,
            companyForeignStateList: null,
            residentialForeignStateList: null,
            cityList: null,
            addressCityList: null,
            companyCityList: null,
            postcodeList: null,
            addressPostcodeList: null,
            companyPostcodeList: null,
            displayNob: null,
            displayOcc: null,
        };
        // this.validate()
    }

    async getOccupationData() {
        let occupationList = await FormsBloc.getOccupationList();
        this.setState({ occupationOpt: occupationList.data });
    }

    async getOccupationClassData(occ, nob) {
        let occClass = await FormsBloc.getOccupationClassList(occ, nob);
        this.handleValueChange(this.getFormFields().occupationClass, occClass.data[0]);
    }

    async getNatureOfBusinessData(occ) {
        let nobList = await FormsBloc.getNatureOfBusiness(occ);
        this.setState({ nobOpt: nobList.data });
    }

    initiateData = async () => {
        console.log("initiateData props : ", await this.props.value)
        let formData = await this.props.value;
        let stateData = this.state.personalDetailsData;
        let occupation = null;
        let natureBusiness = null;

        await this.getOccupationData();

        if (formData) {
            console.log("formData : ", formData)
            await Promise.all(Object.keys(formData).map(async (key) => {
                let value = formData[key];
                if (!(key in initiateDetailsObject) && key !== 'country' && key !== 'addIDNo') {
                    return; //dont add the key that not in initiateDetailsObject
                }

                if (key == 'country') {
                    stateData['nationality'] = stateData[key] || null;
                } else {
                    stateData[key] = formData[key];
                }

                key === 'idType' && console.log(stateData)
                if (key === 'dob' && value && typeof value === 'string' && value !== 'Invalid date') {
                    stateData[key] = value ? moment(value) : null;
                }
                if (key == 'occupation') {
                    occupation = await FormBloc.getOccupationNameByCode(formData[key]);
                }
                if (key == 'natureBusiness') {
                    natureBusiness = await FormBloc.getNobNameByCode(formData['occupation'], formData[key]);
                }

                if (key == 'addIDNo' && value) {
                    if (stateData.addIDType == 'oldIcNo') {
                        stateData.oldIcNo = value;
                    } else if (stateData.addIDType == 'birthCertNo') {
                        stateData.birthCertNo = value;
                    }
                }
            }));
        }
        this.setState({ personalDetailsData: stateData, displayOcc: occupation, displayNob: natureBusiness });
    }

    getQuotationId() {
        return this.props.match.params.itemId;
    }

    getUserDataHeader() {
        return this.state.userDataHeader;
    }
    getUserData() {
        return this.state.userData;
    }

    getEntity() {
        return this.state.route.entity;
    }

    getUserSettings() {
        return this.state.userSettings;
    }

    getFormFields() {
        return this.props.fields;
    }

    generateProfileSettingValue() {
        let userSettings = this.getUserSettings().info[0].value;
        let userData = this.getUserData();
        let value = userData[userSettings];
        return value;
    }

    componentDidMount() {
        let userData = UserAccessBloc.getUserData();
        let userSettings = UserAccessBloc.getUserSettings();
        let name = "";
        let role = "";
        let branch = "";
        let profile = [];
        if (userData) {
            name = userData ? userData.displayName : "";
            role = userData ? userData.designationTitle : "";
            profile = userSettings ? userSettings.module.profile : [];
            this.setState({
                userData: userData,
                userDataHeader: HomeBloc.getUserData(name, role, branch),
                userSettings: profile,
            });
        }
        this.initiateData();
        this.getFormOptList();
    }
    async getFormOptList() {
        this.setState({ loading: true });
        let countryList = await FormBloc.getCountryList();
        let stateList = await FormBloc.getStateList();
        let salutationList = await FormBloc.getSalutationList();
        this.setState({
            countryList: countryList.data,
            stateList: stateList.data,
            salutationList: salutationList.data,
            loading: false
        });
    }

    companyNameByEntity = () => {
        if (this.props.userGlobal) {
            switch (this.props.userGlobal.roles[0].entity) {
                case Config.entity.hsbc.code:
                    return "HSBC Amanah";
                case Config.entity.alliance.code:
                    return "Alliance Islamic Bank Berhad";
                case Config.entity.mbsb.code:
                    return "MBSB Bank Berhad";
                default:
                    return null;
            }
        }

    }

    getInitial(name) {
        let result = GeneralBloc.mergeIntoInitialName(name);
        return result;
    }

    onValidateForm = () => {
        const { personalDetailsData } = this.state;
        let validated = personalDetailsData?.isPayorPersonCovered === 'Yes' ? true : UtilBloc.payorInformationDataValidation(personalDetailsData);
        this.setPropValidation(validated);
        this.setPropValue(personalDetailsData);
        return validated;
    }

    setPropValidation = (result) => {
        this.props.handleValidationResult(result);
    }

    setPropValue = () => {
        let valueobj = this.state.personalDetailsData;
        this.props.onChange(valueobj);
    }

    handleIsForeignTravel(val) {
        this.props.handleForeignTravelQuestionnaireOpen(val);
    }

    handleValueChange = async (field, val, val2) => {
        console.log("field : ", field, "val : ", val)
        let data = this.state.personalDetailsData;
        data[field] = val;

        if (field == 'isPayorPersonCovered' && val == 'Yes' && this.props.personalDetailData) {
            data.name = this.props.personalDetailData.name;
            data.idType = this.props.personalDetailData.idType;
            data.idNo = this.props.personalDetailData.idNo;
            data.dob = this.props.personalDetailData.dob;
            data.addIDType = this.props.personalDetailData.addIDType;
            data.oldIcNo = this.props.personalDetailData.addIDType === 'oldIcNo' ? this.props.personalDetailData.addIDNo || null : null;
            data.birthCertNo = this.props.personalDetailData.addIDType === 'birthCertNo' ? this.props.personalDetailData.addIDNo || null : null;

            let occupation = '';
            let natureBusiness = '';
            await Promise.all(Object.keys(this.props.personalDetailData).map(async (key) => {
                if (!(key in initiateDetailsObject) && key !== 'country') {
                    return; //dont add the key that not in initiateDetailsObject
                }

                if (key === 'country') {
                    data.nationality = this.props.personalDetailData[key] || null
                } else {
                    data[key] = this.props.personalDetailData[key];
                }

                if (key == 'occupation') {
                    occupation = await FormBloc.getOccupationNameByCode(this.props.personalDetailData[key]);
                }
                if (key == 'natureBusiness') {
                    natureBusiness = await FormBloc.getNobNameByCode(this.props.personalDetailData['occupation'], this.props.personalDetailData[key]);
                }
            }));
            this.setState({ displayOcc: occupation, displayNob: natureBusiness })
        }
        if (field == 'isPayorPersonCovered' && val == 'No') {
            await Promise.all(Object.keys(this.state.personalDetailsData).map(async (key) => {
                if (key !== 'isPayorPersonCovered') {
                    if (key == 'isResidentialAddressCorrespondenceAddress') {
                        data[key] = 'Yes';
                        return;
                    }
                    data[key] = ''
                }
            }));
        }

        /* if (
            (data['nationality'] == 'MYS' && data['isLivingInMalaysia'] == 'No') ||
            (data['nationality'] == 'MYS' && data['companyCountry'] != 'MYS' && data['companyCountry'] != 'SGP' && data['companyCountry'] != null) ||
            ((data['nationality'] != 'MYS' || data['idType'] == 'Foreigner - Passport No.') && (data['corrCountry'] == 'MYS'))
        ) {
            this.handleIsForeignTravel(true);
        } else {
            this.handleIsForeignTravel(false);
        } */

        if (field == 'name' || field == 'companyName') {
            const capitalizedName = UtilBloc.capitalizeWords(val);
            const convertApostrophe = capitalizedName.replace(/[\u2018\u2019\u0091\u0092]/g, "'");
            data[field] = convertApostrophe;
        }

        if (field == 'idNo') {
            if (val) {
                if (isContainNumberOnly(val) && val.length > 5) {
                    let dob = this.getBirthdayFromID(val);
                    data.dob = moment(dob, 'DD/MM/YYYY');
                }
            } else {
                data.dob = null;
            }
        }

        if (field == 'country' && val == 'MYS') {
            data.isLivingInMalaysia = 'Yes';
        }
        if (field == 'state') {
            FormBloc.getCityList(val).then((res) => { this.setState({ cityList: res.data }) });
            data.city = null;
        }
        if (field == 'corrState') {
            FormBloc.getCityList(val).then((res) => { this.setState({ addressCityList: res.data }) });
            data.corrPostcode = null;
            data.corrCity = null;
        }
        if (field == 'corrCity') {
            data.corrPostcode = null;
            if (data.corrState && val) {
                FormBloc.getPostcodeList(data.corrState, val).then((res) => { this.setState({ addressPostcodeList: res.data }) });
            }
        }
        if (field == 'residentialState') {
            FormBloc.getCityList(val).then((res) => { this.setState({ residentialCityList: res.data }) });
            data.residentialPostcode = null;
            data.residentialCity = null;
        }
        if (field == 'residentialCity') {
            data.residentialPostcode = null;
            if (data.residentialState && val) {
                FormBloc.getPostcodeList(data.residentialState, val).then((res) => { this.setState({ residentialPostcodeList: res.data }) });
            }
        }
        if (field === 'occupation') {
            this.getNatureOfBusinessData(val);
            if (val && data?.nob) {
                this.getOccupationClassData(val, data.nob);
            }
        }
        if (field === 'natureBusiness') {
            if (val && data?.natureBusiness) {
                this.getOccupationClassData(data.occupation, val);
            }
        }
        if (field == 'country' && val != 'MYS') {
            data.state = null;
            data.city = null;
        }
        if (field == 'corrCountry') {
            data.residentialCountry = val;
            if (val != 'MYS') {
                data.corrState = null;
                data.corrCity = null;
                data.corrPostcode = null;
                data.residentialState = null;
                data.residentialCity = null;
                data.residentialPostcode = null;
                FormBloc.getStateByCountryCode(val).then((res) => { this.setState({ corrForeignStateList: res.data, residentialForeignStateList: res.data }) });
                this.setState({
                    personalDetailsData: {
                        ...this.state.personalDetailsData,
                        corrState: null,
                        corrCity: null,
                        corrPostcode: null
                    }
                });
            }
        }
        if (field == 'corrCountry' && val == 'MYS') {
            data.corrState = null;
            data.corrCity = null;
            data.corrPostcode = null;
            this.setState({
                personalDetailsData: {
                    ...this.state.personalDetailsData,
                    corrState: null,
                    corrCity: null,
                    corrPostcode: null
                },
                corrForeignStateList: null,
                residentialForeignStateList: null
            });
        }
        if (field == 'companyCountry' && val != 'MYS') {
            data.companyState = null;
            data.companyPostcode = null;
            data.companyCity = null;
            FormBloc.getStateByCountryCode(val).then((res) => { this.setState({ companyForeignStateList: res.data }) });
            this.setState({
                personalDetailsData: {
                    ...this.state.personalDetailsData,
                    companyState: null,
                    companyCity: null,
                    companyPostcode: null
                }
            });
        }
        if (field == 'companyCountry' && val == 'MYS') {
            data.companyState = null;
            data.companyPostcode = null;
            data.companyCity = null;
            this.setState({
                personalDetailsData: {
                    ...this.state.personalDetailsData,
                    companyState: null,
                    companyCity: null,
                    companyPostcode: null
                },
                companyForeignStateList: null
            });
        }
        if (field == 'residentialCountry' && val != 'MYS') {
            data.residentialState = null;
            data.residentialPostcode = null;
            data.residentialCity = null;
            FormBloc.getStateByCountryCode(val).then((res) => { this.setState({ residentialForeignStateList: res.data }) });
        }
        if (field == 'residentialCountry' && val == 'MYS') {
            this.setState({ residentialForeignStateList: null });
        }
        if (field == 'companyState') {
            data.companyPostcode = null;
            data.companyCity = null;
            FormBloc.getCityList(val).then((res) => { this.setState({ companyCityList: res.data }) });
        }
        if (field == 'companyCity') {
            data.companyPostcode = null;
            if (data.companyState && val) {
                FormBloc.getPostcodeList(data.companyState, val).then((res) => { this.setState({ companyPostcodeList: res.data }) });
            }
        }

        if (field == 'correspondenceAddress' && data.isResidentialAddressCorrespondenceAddress == 'Yes') {
            data.residentialAddress = val;
        }
        if (field == 'correspondenceAddress2' && data.isResidentialAddressCorrespondenceAddress == 'Yes') {
            data.residentialAddress2 = val;
        }
        if (field == 'correspondenceAddress3' && data.isResidentialAddressCorrespondenceAddress == 'Yes') {
            data.residentialAddress3 = val;
        }
        if (field == 'corrState' && data.isResidentialAddressCorrespondenceAddress == 'Yes') {
            data.residentialState = val;
        }
        if (field == 'corrCity' && data.isResidentialAddressCorrespondenceAddress == 'Yes') {
            data.residentialCity = val;
        }
        if (field == 'corrPostcode' && data.isResidentialAddressCorrespondenceAddress == 'Yes') {
            data.residentialPostcode = val;
        }

        if (field == 'isResidentialAddressCorrespondenceAddress' && val == 'Yes') {
            data.residentialAddress = data.correspondenceAddress;
            data.residentialAddress2 = data.correspondenceAddress2;
            data.residentialAddress3 = data.correspondenceAddress3;
            data.residentialState = data.corrState;
            data.residentialCity = data.corrCity;
            data.residentialPostcode = data.corrPostcode;
            data.residentialCountry = data.corrCountry;
        }
        if (field == 'isResidentialAddressCorrespondenceAddress' && val == 'No') {
            data.residentialAddress = null;
            data.residentialAddress2 = null;
            data.residentialAddress3 = null;
            data.residentialState = null;
            data.residentialCity = null;
            data.residentialPostcode = null;
            data.residentialCountry = data.corrCountry;
        }
        let validation = this.onValidateForm();
        console.log("validation : ", validation)
    }

    //residential end

    getBirthdayFromID(idNo) {
        const Year = idNo.substring(0, 2);
        const Month = idNo.substring(2, 4);
        const Day = idNo.substring(4, 6);

        var cutoff = new Date().getFullYear() - 2000;
        var dob = Day + "/" + Month + "/" + (Year > cutoff ? "19" : "20") + Year;

        return moment(dob, 'DD/MM/YYYY');
    }

    handleNRICChange = async (idNo) => {
        await this.handleValueChange(this.getFormFields().idNo, idNo);
        if (idNo) {
            if (isContainNumberOnly(idNo) && idNo.length > 5) {
                let dob = this.getBirthdayFromID(idNo);
                this.setState({
                    idNo: idNo,
                    dob: moment(dob, 'DD/MM/YYYY')
                });
            } else {
                this.setState({ idNo: idNo })
            }
        } else {
            this.setState({
                idNo: idNo,
                dob: null,
                age: null,
                erroridNoInd: UtilBloc.nricValidation(idNo)
            });
        }

    }

    showerror = (val) => {
        return val !== null && UtilBloc.isNullOrEmpty(val)
    }
    emailValidation = (val) => {
        return val !== null && UtilBloc.emailValidation(val)
    }
    showExtraFormError = (parent, val, ind) => {
        if (parent === ind) {
            return val !== null && UtilBloc.isNullOrEmpty(val)
        }
        else
            return false
    }

    representativeForm(data) {
        return (
            <AppTextField
                title={data.title}
                type={'text'}
                disabled={true}
                value={data.value}
            />
        )
    }

    personCoveredForm(data, onChange, type = 'text', placeholder, prefix = '', suffix = '') {
        if (type === 'select') {
            return (
                <AppSelectField
                    title={data.title}
                    value={data.value}
                    placeholder={placeholder}
                    options={Config.quotation.optionItem.gender}
                    onChange={onChange}
                />
            )
        }
        else if (type === 'selectButton') {
            return (
                <AppSelectButton
                    title={data.title}
                    value={data.value}
                    handleNegativePress={() => onChange('No')}
                    handlePositivePress={() => onChange('Yes')}
                // error={this.state.errorFinanceInd}
                // errorMessage={this.state.errorMessage}
                />
            )
        }
        else {
            return (
                <AppTextField
                    title={data.title}
                    type={type}
                    placeholder={placeholder}
                    prefix={prefix}
                    suffix={suffix}
                    onChange={onChange}
                    value={data.value}
                />
            )
        }

    }
    relationshipToPersonCovered() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.relationshipToPersonCovered}
                value={this.state.personalDetailsData.relationshipToPersonCovered}
                placeholder={'Select relationship...'}
                options={Config.proposal.optionItem.relationship}
                onChange={(e) => this.handleValueChange(this.getFormFields().relationshipToPersonCovered, e)}
            />
        )
    }
    specifyRelationship() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.specifyRelationship}
                value={this.state.personalDetailsData.specifyRelationship}
                type={'text'}
                onChange={(e) => this.handleValueChange(this.getFormFields().specifyRelationship, e)}
                placeholder={'Enter relationship to the person covered'}
            // disabled={true}
            />
        )
    }
    personCoveredName() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.name}
                type={'text'}
                placeholder={'Enter full name...'}
                disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
                value={this.state.personalDetailsData.name}
                onChange={(e) => this.handleValueChange(this.getFormFields().name, e)}
                onValidate={(value) => { return UtilBloc.nameValidation(value) }}
                errorMessage={nameValidation(this.state.personalDetailsData.name) || 'Fill in the required field.'}
                maxLength={60}
            />
        )
    }

    personCoveredIdType() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.idType}
                placeholder={'Select ID Type...'}
                options={Config.quotation.optionItem.idType}
                disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
                value={this.state.personalDetailsData.idType}
                onChange={(e) => this.handleValueChange(this.getFormFields().idType, e)}
            />
        )
    }
    personCoveredIcNo() {
        return (
            <AppTextField
                title={
                    this.state.personalDetailsData.idType == 'IC' ? 'IC No.' :
                        this.state.personalDetailsData.idType == 'Police/Army' ? 'Identify No.' :
                            'Passport No.'
                }
                placeholder={
                    this.state.personalDetailsData.idType == 'IC' || this.state.personalDetailsData.idType == 'Police/Army' ?
                        'YYMMDDBP###G' : 'Enter your identify number...'
                }
                type={'text'}
                disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
                value={this.state.personalDetailsData.idNo}
                onChange={(e) => this.handleValueChange(this.getFormFields().idNo, e)}
            />
        )
    }

    addIDType = () => {
        return (
            <AppSelectField
                title={'Additional ID Type'}
                value={this.state.personalDetailsData.addIDType}
                placeholder={'Select...'}
                options={Config.quotation.optionItem.additionalID}
                onChange={(e) => this.handleValueChange(this.getFormFields().addIDType, e === 'clear' ? null : e)}
                disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
                error={this.state.errorAddIdTypeInd}
                errorMessage={this.state.errorMessage}
                clearEnabled={true}
            />
        )
    }

    additionalIdNumber = () => {
        return (
            <AppTextField
                title={
                    this.state.personalDetailsData?.addIDType == 'oldIcNo' ? 'Old IC No.' :
                        'Birth Certificate ID'
                }
                placeholder={
                    this.state.personalDetailsData?.addIDType == 'oldIcNo' ?
                        'YYMMDDBP###G' : 'Enter your birth certificate number...'
                }
                type={'text'}
                value={this.state.personalDetailsData?.addIDType == 'oldIcNo' ? this.state.personalDetailsData.oldIcNo : this.state.personalDetailsData.birthCertNo}
                onChange={(e) => this.handleValueChange(this.state.personalDetailsData?.addIDType == 'oldIcNo' ? this.getFormFields().oldIcNo : this.getFormFields().birthCertNo, e)}
                onValidate={(value) => {
                    return UtilBloc.isNullOrEmpty(value)
                }}
                disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
                errorMessage={this.state.errorMessage}
            />
        )
    }
    personCoveredDob() {
        return (
            this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ?
                <AppTextField
                    title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.dob}
                    type={'text'}
                    disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
                    onChange={(e) => this.handleValueChange(this.getFormFields().dob, e)}
                    value={this.state.personalDetailsData?.dob}
                />
                : <>
                    Date of Birth
                    <DatePicker
                        onChange={(d) => this.handleValueChange(this.getFormFields().dob, d)}
                        style={{ height: '48px', width: '100%', marginTop: '1vh' }}
                        placeholder="DD/MM/YYYY"
                        format={'DD/MM/YYYY'}
                        disabled={
                            this.state.personalDetailsData?.idType == 'IC' || this.state.personalDetailsData?.idType == 'Police/Army' ?
                                true : false
                        }
                        value={this.state.personalDetailsData?.dob}
                    // renderExtraFooter={() =>
                    //     <p style={{ lineHeight: '16px' }}>ANB cannot be more than 66, & less than 18 years old. Please select a year between 1958 - 2005</p>
                    // }
                    />
                </>
        )
    }
    contributorIsPersonCovered() {
        return (
            <AppSelectButton
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.isPayorPersonCovered}
                handleNegativePress={() => this.handleValueChange(this.getFormFields().isPayorPersonCovered, 'No')}
                handlePositivePress={() => this.handleValueChange(this.getFormFields().isPayorPersonCovered, 'Yes')}
                value={this.state.personalDetailsData.isPayorPersonCovered}
                onChange={(e) => this.handleValueChange(this.getFormFields().isPayorPersonCovered, e)}
            />
        )
    }
    nationality = () => {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.nationality}
                value={this.state.personalDetailsData.nationality}
                disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
                showSearch={true}
                placeholder={'Select nationality...'}
                // options={FormBloc.getCountrySelections(true)}
                options={this.state.countryList || []}
                fieldNames={{ label: ('reference1'), value: ('code') }}
                onChange={(e) => this.handleValueChange(this.getFormFields().nationality, e)}
            />
        )
    }

    personCoveredNatureOfBusiness() {
        return (
            this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ?
                <AppTextField
                    title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.natureBusiness}
                    type={'text'}
                    disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
                    value={this.state.displayNob}
                />
                :
                <AppSelectField
                    title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.natureBusiness}
                    type={'text'}
                    options={this.state.nobOpt}
                    onChange={(e) => this.handleValueChange(this.getFormFields().natureBusiness, e)}
                    fieldNames={{ label: ('reference1'), value: ('code') }}
                    placeholder={'Select nature of business...'}
                    showSearch={true}
                    disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
                    value={this.state.personalDetailsData.natureBusiness}
                />
        )
    }

    personCoveredCountry() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.country}
                disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
                value={this.state.personalDetailsData.corrCountry}
                showSearch={true}
                placeholder={'Select country...'}
                options={this.state.personalDetailsData.isLivingInMalaysia === 'No' ? this.state.countryList?.length > 0 && this.state.countryList.filter((item) => item.code !== 'MYS') : (this.state.countryList || [])}
                fieldNames={{ label: ('reference1'), value: ('code') }}
                onChange={(e) => this.handleValueChange(this.getFormFields().corrCountry, e)}
            />
        )
    }
    personCoveredCorrespondingAddress() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.correspondenceAddress}
                type={'text'}
                placeholder={'House no./Unit no/Lot no., Block no., Residence/Building'}
                disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
                value={this.state.personalDetailsData.correspondenceAddress}
                onChange={(e) => this.handleValueChange(this.getFormFields().correspondenceAddress, e)}
                maxLength={59}
            />
        )
    }
    personCoveredCorrespondingAddress2() {
        return (
            <AppTextField
                type={'text'}
                placeholder={'Street no./Street Name (Optional)'}
                disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
                value={this.state.personalDetailsData.correspondenceAddress2}
                onChange={(e) => this.handleValueChange(this.getFormFields().correspondenceAddress2, e)}
                maxLength={59}
            />
        )
    }
    personCoveredCorrespondingAddress3() {
        return (
            <AppTextField
                type={'text'}
                placeholder={'Optional'}
                disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
                value={this.state.personalDetailsData.correspondenceAddress3}
                onChange={(e) => this.handleValueChange(this.getFormFields().correspondenceAddress3, e)}
                maxLength={59}
            />
        )
    }
    personCoveredState() {
        const country = this.state.personalDetailsData.corrCountry;
        const stateOptions = (country == 'MYS' || country == null) ? (this.state.stateList || FormBloc.getStateSelections()) : (this.state.corrForeignStateList || []);
        const fieldNames = (country == 'MYS' || country == null) ?
            (this.state.stateList ? { label: ('reference1'), value: ('code') } : { label: ('stateName'), value: ('stateCode') }) :
            (this.state.corrForeignStateList ? { label: ('reference1'), value: ('code') } : { label: ('stateName'), value: ('stateCode') });
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.state}
                value={this.state.personalDetailsData.corrState}
                placeholder={'Select state...'}
                options={stateOptions}
                fieldNames={fieldNames}
                onChange={(e) => this.handleValueChange(this.getFormFields().corrState, e)}
                disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
            />
        )
    }
    personCoveredPostcode() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.postcode}
                type={'text'}
                placeholder={'Select postcode...'}
                value={this.state.personalDetailsData.corrPostcode}
                options={this.state.addressPostcodeList || []}
                fieldNames={{ label: ('reference1'), value: ('code') }}
                onChange={(e) => this.handleValueChange(this.getFormFields().corrPostcode, e)}
                disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
            />
        )
    }
    personCoveredCity() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.city}
                type={'text'}
                placeholder={'Select city...'}
                value={this.state.personalDetailsData.corrCity}
                options={
                    this.state.addressCityList || []//FormBloc.getCitySelections()
                }
                fieldNames={this.state.addressCityList ? { label: ('reference1'), value: ('code') } : { label: ('cityName'), value: ('cityName') }}
                onChange={(e) => this.handleValueChange(this.getFormFields().corrCity, e)}
                disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
            />
        )
    }

    // Residential address start
    personCoveredResidentialCountry = () => {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.residentialCountry}
                type={'text'}
                placeholder={'Select country...'}
                value={this.state.personalDetailsData.residentialCountry}
                onChange={(e) => this.handleValueChange(this.getFormFields().residentialCountry, e)}
                options={this.state.countryList || FormBloc.getCountrySelections(true)}
                fieldNames={this.state.countryList ? { label: ('reference1'), value: ('code') } : {}}
                showSearch={true}
                disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
            />
        )
    }
    personCoveredIsResidentialAddressCorrespondenceAddress() {
        return (
            <AppSelectButton
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.isResidentialAddressCorrespondenceAddress}
                handleNegativePress={() => this.handleValueChange(this.getFormFields().isResidentialAddressCorrespondenceAddress, 'No')}
                handlePositivePress={() => this.handleValueChange(this.getFormFields().isResidentialAddressCorrespondenceAddress, 'Yes')}
                value={this.state.personalDetailsData.isResidentialAddressCorrespondenceAddress}
                disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
            />
        )
    }
    personCoveredResidentialAddress() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.residentialAddress}
                type={'text'}
                placeholder={'House no./Unit no/Lot no., Block no., Residence/Building'}
                value={this.state.personalDetailsData.residentialAddress}
                onChange={(e) => this.handleValueChange(this.getFormFields().residentialAddress, e)}
                error={this.showExtraFormError(this.state.personalDetailsData.isResidentialAddressCorrespondenceAddress, this.state.personalDetailsData.residentialAddress, "No")}
                errorMessage={this.state.errorMessage}
                maxLength={59}
                disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
            />
        )
    }
    personCoveredResidentialState() {
        const country = this.state.personalDetailsData.residentialCountry;
        const stateOptions = (country == 'MYS' || country == null) ? (this.state.stateList || FormBloc.getStateSelections()) : (this.state.residentialForeignStateList || []);
        const fieldNames = (country == 'MYS' || country == null) ?
            (this.state.stateList ? { label: ('reference1'), value: ('code') } : { label: ('stateName'), value: ('stateCode') }) :
            (this.state.residentialForeignStateList ? { label: ('reference1'), value: ('code') } : { label: ('stateName'), value: ('stateCode') });
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.state}
                value={this.state.personalDetailsData.residentialState}
                placeholder={'Select state...'}
                options={stateOptions}
                fieldNames={fieldNames}
                onChange={(e) => this.handleValueChange(this.getFormFields().residentialState, e)}
                disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
            />
        )
    }
    personCoveredResidentialPostcode() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.postcode}
                value={this.state.personalDetailsData.residentialPostcode}
                placeholder={'Enter postcode...'}
                options={this.state.residentialPostcodeList || []}
                fieldNames={{ label: ('reference1'), value: ('code') }}
                onChange={(e) => this.handleValueChange(this.getFormFields().residentialPostcode, e)}
                disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
            />
        )
    }
    personCoveredResidentialCity() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.city}
                value={this.state.personalDetailsData.residentialCity}
                placeholder={'Enter city...'}
                options={
                    this.state.residentialCityList || []//FormBloc.getCitySelections()
                }
                fieldNames={this.state.residentialCityList ? { label: ('reference1'), value: ('code') } : { label: ('cityName'), value: ('cityName') }}
                onChange={(e) => this.handleValueChange(this.getFormFields().residentialCity, e)}
                disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
            />
        )
    }
    personCoveredResidentialAddress2() {
        return (
            <AppTextField
                type={'text'}
                placeholder={'Street no./Street Name (Optional)'}
                value={this.state.personalDetailsData.residentialAddress2}
                onChange={(e) => this.handleValueChange(this.getFormFields().residentialAddress2, e)}
                disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
                maxLength={59}
            />
        )
    }
    personCoveredResidentialAddress3() {
        return (
            <AppTextField
                type={'text'}
                placeholder={'Optional'}
                value={this.state.personalDetailsData.residentialAddress3}
                onChange={(e) => this.handleValueChange(this.getFormFields().residentialAddress3, e)}
                disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
                maxLength={59}
            />
        )
    }
    // Residential address end

    personCoveredOccupation() {
        return (
            this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ?
                <AppTextField
                    title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.occupation}
                    type={'text'}
                    disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
                    value={this.state.displayOcc}
                />
                :
                <AppSelectField
                    title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.occupation}
                    placeholder={'Select occupation...'}
                    onChange={(e) => this.handleValueChange(this.getFormFields().occupation, e)}
                    options={this.state.occupationOpt}
                    fieldNames={{ label: ('reference1'), value: ('code') }}
                    value={this.state.personalDetailsData.occupation}
                    disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
                />
        )
    }
    personCoveredAnnualIncome() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.annualIncome}
                placeholder={'Select annual income...'}
                onChange={(e) => this.handleValueChange(this.getFormFields().annualIncome, e)}
                // onValidate={(value) => { return !UtilBloc.validateDecimal(value) }}
                options={Config.proposal.optionItem.incomeRange}
                // errorMessage={decimalNumberValidation(this.state.personalDetailsData.annualIncome)}
                // disabled={true}
                value={this.state.personalDetailsData.annualIncome}
                disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
            />
        )
    }
    personCoveredExactAnnualIncome() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.exactAnnualIncome}
                type={'text'}
                prefix={'RM '}
                placeholder={'Enter exact annual income...'}
                onChange={(e) => {
                    if (e) {
                        let value = e;
                        if (/^\d*\.?\d*$/.test(value) && value.length <= 16) {
                            this.handleValueChange(this.getFormFields().exactAnnualIncome, value);
                        }
                    } else {
                        this.handleValueChange(this.getFormFields().exactAnnualIncome, e)
                    }
                }}
                onValidate={(value) => { return !UtilBloc.validateDecimal(value) }}
                errorMessage={decimalNumberValidation(this.state.personalDetailsData.exactAnnualIncome)}
                // disabled={true}
                value={this.state.personalDetailsData.exactAnnualIncome}
                disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
            />
        )
    }
    personCoveredOccClass() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.occupationClass}
                value={this.state.personalDetailsData.occupationClass}
                onChange={(e) => this.handleValueChange(this.getFormFields().occupationClass, e)}
                placeholder={'Select occupation class...'}
                options={Config.quotation.optionItem.occupationClass}
                disabled={true}
            />
        )
    }
    personCoveredExactDuties() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.exactDuties}
                type={'text'}
                placeholder={'Describe the duties you\'re managing...'}
                multiline={true}
                showCount
                maxLength={1000}
                value={this.state.personalDetailsData.exactDuties}
                onChange={(e) => this.handleValueChange(this.getFormFields().exactDuties, e)}
                error={this.showerror(this.state.personalDetailsData.exactDuties)}
                errorMessage={this.state.errorMessage}
                disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
            />
        )
    }
    personCoveredMobileNo() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.mobileNo}
                type={'text'}
                placeholder={'Enter mobile phone number...'}
                value={this.state.personalDetailsData.mobileNo}
                onChange={(e) => (this.handleValueChange(this.getFormFields().mobileNo, e))}
                onValidate={(value) => { return UtilBloc.phoneNumberValidation(value) }}
                // error={this.showerror(this.state.personalDetailsData.mobileNo)}
                errorMessage={phoneNumberValidation(this.state.personalDetailsData.mobileNo)}
                disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
            />
        )
    }
    personCoveredOfficePhoneNumber() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.officePhoneNo}
                type={'text'}
                placeholder={'Enter office phone number (Optional)'}
                value={this.state.personalDetailsData.officePhoneNo}
                onChange={(e) => this.handleValueChange(this.getFormFields().officePhoneNo, e)}
                onValidate={(value) => { return value !== '' && UtilBloc.phoneNumberValidation(value) }}
                error={this.state.personalDetailsData.officePhoneNo !== '' && this.showerror(this.state.personalDetailsData.officePhoneNo)}
                errorMessage={this.state.personalDetailsData.officePhoneNo !== '' && phoneNumberValidation(this.state.personalDetailsData.officePhoneNo)}
                disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
            />
        )
    }
    personCoveredHomePhoneNumber() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.homePhoneNo}
                type={'text'}
                placeholder={'Enter home phone number (Optional)'}
                value={this.state.personalDetailsData.homePhoneNo}
                onChange={(e) => this.handleValueChange(this.getFormFields().homePhoneNo, e)}
                onValidate={(value) => { return value !== '' && UtilBloc.phoneNumberValidation(value) }}
                error={this.state.personalDetailsData.homePhoneNo !== '' && this.showerror(this.state.personalDetailsData.homePhoneNo)}
                errorMessage={this.state.personalDetailsData.homePhoneNo !== '' && phoneNumberValidation(this.state.personalDetailsData.homePhoneNo)}
                disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
            />
        )
    }
    personCoveredEmail() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.email}
                type={'text'}
                placeholder={'Enter email...'}
                value={this.state.personalDetailsData.email}
                onChange={(e) => this.handleValueChange(this.getFormFields().email, e)}
                error={this.emailValidation(this.state.personalDetailsData.email)}
                errorMessage={"Invalid email format"}
                disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
            />
        )
    }
    personCoveredCompanyName() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.companyName}
                type={'text'}
                placeholder={'Enter your company name...'}
                value={this.state.personalDetailsData.companyName}
                onChange={(e) => this.handleValueChange(this.getFormFields().companyName, e)}
                onValidate={(value) => { return UtilBloc.nameValidation(value, true) }}
                error={this.showerror(this.state.personalDetailsData.companyName)}
                errorMessage={nameValidation(this.state.personalDetailsData.companyName, true) || 'Fill in the required field.'}
                disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
                maxLength={60}
            />
        )
    }
    personCoveredCompanyAddress() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.companyAddress}
                type={'text'}
                placeholder={'Enter floor / unit / street name...'}
                value={this.state.personalDetailsData.companyAddress}
                onChange={(e) => this.handleValueChange(this.getFormFields().companyAddress, e)}
                error={this.showerror(this.state.personalDetailsData.companyAddress)}
                errorMessage={this.state.errorMessage}
                maxLength={59}
                disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
            />
        )
    }
    personCoveredCompanyAddress2() {
        return (
            <AppTextField
                type={'text'}
                placeholder={'Street no./Street Name (Optional)'}
                value={this.state.personalDetailsData.companyAddress2}
                onChange={(e) => this.handleValueChange(this.getFormFields().companyAddress2, e)}
                maxLength={59}
                disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
            />
        )
    }
    personCoveredCompanyAddress3() {
        return (
            <AppTextField
                type={'text'}
                placeholder={'Optional'}
                value={this.state.personalDetailsData.companyAddress3}
                onChange={(e) => this.handleValueChange(this.getFormFields().companyAddress3, e)}
                maxLength={59}
                disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
            />
        )
    }
    personCoveredCompanyCountry = () => {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.companyCountry}
                type={'text'}
                placeholder={'Select country...'}
                value={this.state.personalDetailsData.companyCountry}
                onChange={(e) => this.handleValueChange(this.getFormFields().companyCountry, e)}
                options={this.state.countryList || FormBloc.getCountrySelections(true)}
                fieldNames={this.state.countryList ? { label: ('reference1'), value: ('code') } : {}}
                showSearch={true}
                disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
            />
        )
    }
    personCoveredCompanyState() {
        const country = this.state.personalDetailsData.companyCountry;
        const stateOptions = (country == 'MYS' || country == null) ? (this.state.stateList || FormBloc.getStateSelections()) : (this.state.companyForeignStateList || []);
        const fieldNames = (country == 'MYS' || country == null) ?
            (this.state.stateList ? { label: ('reference1'), value: ('code') } : { label: ('stateName'), value: ('stateCode') }) :
            (this.state.companyForeignStateList ? { label: ('reference1'), value: ('code') } : { label: ('stateName'), value: ('stateCode') });
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.companyState}
                value={this.state.personalDetailsData.companyState}
                placeholder={'Select state...'}
                options={stateOptions}
                fieldNames={fieldNames}
                onChange={(e) => this.handleValueChange(this.getFormFields().companyState, e)}
                disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
            />
        )
    }
    personCoveredCompanyPostcode() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.companyPostcode}
                value={this.state.personalDetailsData.companyPostcode}
                placeholder={'Enter postcode...'}
                options={this.state.companyPostcodeList || []}
                fieldNames={{ label: ('reference1'), value: ('code') }}
                onChange={(e) => this.handleValueChange(this.getFormFields().companyPostcode, e)}
                disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
            />
        )
    }
    personCoveredCompanyCity() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.companyCity}
                value={this.state.personalDetailsData.companyCity}
                placeholder={'Enter city...'}
                options={
                    this.state.companyCityList || []//FormBloc.getCitySelections()
                }
                fieldNames={this.state.companyCityList ? { label: ('reference1'), value: ('code') } : { label: ('cityName'), value: ('cityName') }}
                onChange={(e) => this.handleValueChange(this.getFormFields().companyCity, e)}
                disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
            />
        )
    }
    preferContactMode() {
        return (
            <AppSelectButton
                title={Config.proposal.formDataMapping.step1.personCoveredFormTitle.preferContactMode}
                negativeButtonText={'Mobile Number'}
                positiveButtonText={'Email'}
                handleNegativePress={() => this.handleValueChange(this.getFormFields().preferContactMode, 'Mobile Number')}
                handlePositivePress={() => this.handleValueChange(this.getFormFields().preferContactMode, 'Email')}
                value={this.state.personalDetailsData.preferContactMode}
                disabled={this.state.personalDetailsData.isPayorPersonCovered === 'Yes' ? true : false}
            />
        )
    }

    render() {
        console.log("personalDetailsData(props) : ", this.props.personalDetailData)
        console.log("personalDetailsData(state) : ", this.state.personalDetailsData)
        console.log("displayNob: ", this.state.displayNob)
        return (
            <>
                <span style={{ color: 'red', fontStyle: 'italic', fontSize: '14px' }}>All fields are required</span>
                <div className="">
                    <div className="row m-0 w-100">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.contributorIsPersonCovered()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                        </div>
                    </div>
                    {
                        this.state.personalDetailsData.isPayorPersonCovered === 'No' &&
                        <div className="row m-0 w-100 mt-2">
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                {this.relationshipToPersonCovered()}
                            </div>
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                {this.specifyRelationship()}
                            </div>
                        </div>
                    }
                    <div className="row m-0 w-100 mt-2">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredName()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                        </div>
                    </div>
                    <div className="row m-0 w-100 mt-2">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredIdType()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredIcNo()}
                        </div>
                    </div>
                    <div className="row m-0 w-100 mt-2">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.addIDType()}
                        </div>
                        {
                            (this.state.personalDetailsData.addIDType == 'oldIcNo' || this.state.personalDetailsData.addIDType == 'birthCertNo') &&
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                {this.additionalIdNumber()}
                            </div>
                        }
                    </div>
                    <div className="row m-0 w-100 mt-2">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredDob()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                        </div>
                    </div>
                    <div className="row m-0 w-100 mt-2">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                            {this.nationality()}
                        </div>
                    </div>
                    <div className="row m-0 w-100 mt-3">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredOccupation()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredOccClass()}
                        </div>
                    </div>
                    <div className="row m-0 w-100 mt-2">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredAnnualIncome()}
                        </div>
                        {
                            this.state.personalDetailsData.annualIncome === '> RM200,000' &&
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                {this.personCoveredExactAnnualIncome()}
                            </div>
                        }
                    </div>
                    <div className="row m-0 w-100 mt-2">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredCompanyName()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredNatureOfBusiness()}
                        </div>
                    </div>
                    <div className="row m-0 w-100 mt-2">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredCompanyCountry()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredCompanyAddress()}
                        </div>
                    </div>
                    <div className="row m-0 w-100 mt-2">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredCompanyAddress2()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredCompanyAddress3()}
                        </div>
                    </div>
                    {
                        <div className="row m-0 w-100 mt-2">
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                {this.personCoveredCompanyState()}
                            </div>
                            {
                                this.state.personalDetailsData.companyCountry == 'MYS' || this.state.personalDetailsData.companyCountry == null ?
                                    <div className="col-lg-6 col-sm-12 row m-0 p-0">
                                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                            {this.personCoveredCompanyCity()}
                                        </div>
                                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                            {this.personCoveredCompanyPostcode()}
                                        </div>
                                    </div> : <></>
                            }
                        </div>
                    }

                    <div className="row m-0 w-100 mt-3">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredCountry()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredCorrespondingAddress()}
                        </div>
                    </div>
                    <div className="row m-0 w-100 mt-3">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredCorrespondingAddress2()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredCorrespondingAddress3()}
                        </div>
                    </div>
                    {
                        <div className="row m-0 w-100 mt-2">
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                                {this.personCoveredState()}
                            </div>
                            {
                                this.state.personalDetailsData.corrCountry == 'MYS' || this.state.personalDetailsData.corrCountry == null ?
                                    <div className="col-lg-6 col-sm-12 row m-0 p-0">
                                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                            {this.personCoveredCity()}
                                        </div>
                                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                            {this.personCoveredPostcode()}
                                        </div>
                                    </div> : <></>
                            }
                        </div>
                    }
                    <div className="row m-0 w-100 mt-3">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredIsResidentialAddressCorrespondenceAddress()}
                        </div>
                        {
                            this.state.personalDetailsData.isResidentialAddressCorrespondenceAddress === "No" &&
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                {this.personCoveredResidentialAddress()}
                            </div>
                        }
                    </div>
                    {
                        this.state.personalDetailsData.isResidentialAddressCorrespondenceAddress === "No" &&
                        <>
                            {/* <div className="row m-0 w-100 mt-2">
                                <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                    {this.personCoveredResidentialCountry()}
                                </div>
                                <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                    {this.personCoveredResidentialAddress()}
                                </div>
                            </div> */}
                            <div className="row m-0 w-100 mt-2">
                                <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                    {this.personCoveredResidentialAddress2()}
                                </div>
                                <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                    {this.personCoveredResidentialAddress3()}
                                </div>
                            </div>
                        </>
                    }
                    {
                        this.state.personalDetailsData.isResidentialAddressCorrespondenceAddress === "No" &&
                        <div className="row m-0 w-100 mt-2">
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                                {this.personCoveredResidentialState()}
                            </div>
                            {
                                this.state.personalDetailsData.residentialCountry === 'MYS' || this.state.personalDetailsData.residentialCountry == null ?
                                    <div className="col-lg-6 col-sm-12 row m-0 p-0">
                                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                            {this.personCoveredResidentialCity()}
                                        </div>
                                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                            {this.personCoveredResidentialPostcode()}
                                        </div>
                                    </div> : <></>
                            }
                        </div>
                    }
                    <div className="row m-0 w-100 mt-2">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredOfficePhoneNumber()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredHomePhoneNumber()}
                        </div>
                    </div>
                    <div className="row m-0 w-100 mt-2">
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredMobileNo()}
                        </div>
                        <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                            {this.personCoveredEmail()}
                        </div>
                    </div>
                </div >
            </>
        );
    }
}


const mapStateToProps = (state) => ({
    userGlobal: state.user.value,
    globalFilterBy: state.filter.value,
    globalSearchBy: state.searchBy.value,
    userConfigGlobal: state.userConfig.value,
});

export default withRouter(connect(mapStateToProps)(ContributorPersonalInfo));